import { isIFrame } from 'utils/isIFrame'
import { useFlipperFlag } from './useFlipperFlag'

export const useIframeWrapperSetup = (): void => {
  const useWrapper = useFlipperFlag('iframe_wrapper')
  localStorage.setItem('iframe_wrapper', useWrapper ? 'true' : 'false')
}

export const useIframeWrapper = (): boolean => {
  return localStorage.getItem('iframe_wrapper') === 'true'
}

export const isWrappedFrame = () => {
  return isIFrame() && localStorage.getItem('iframe_wrapper') === 'true'
}
